export default __webpack_public_path__ + "static/media/Slider_2500_Mobile.9acaa419.png";